/** Primary UI font for Tracker AI charts (match mizfatools panel typography). */
export const PANEL_FONT_FAMILY = 'dana, Tahoma, sans-serif';
